// import React, { useState, useEffect } from 'react';
// import Logo from '../../assets/Logo.svg';
// import bgImage from "../../assets/back.png";
// import { useNavigate } from 'react-router-dom';
// const SignupPassword = () => {
//   const [otp, setOtp] = useState(['', '', '', '']);
//   const [timer, setTimer] = useState(20);
//    const navigate = useNavigate();
//   useEffect(() => {
//     const countdown = setInterval(() => {
//       setTimer(prev => (prev > 0 ? prev - 1 : 0));
//     }, 1000);
//     return () => clearInterval(countdown);
//   }, []);

//   const handleOtpChange = (index, value) => {
//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);
//     if (value && index < 3) {
//       document.getElementById(`otp-${index + 1}`).focus();
//     }
//   };

//   return (
//     <div
//       className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
//       style={{ backgroundImage: `url(${bgImage})` }}
//     >
//       <div className="flex flex-col items-center relative">
//         <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

//         <div className="bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[384px] p-8 text-center">
//           <h2 className="text-xl font-bold text-[#2D0076] mb-2">Please Check your email</h2>
//           <p className="text-sm text-[#202224] mb-6">We have sent a code to johndoe@gmail.cm</p>

//           <div className="flex justify-center gap-3 mb-4">
//             {otp.map((digit, index) => (
//               <input
//                 key={index}
//                 id={`otp-${index}`}
//                 type="text"
//                 maxLength="1"
//                 value={digit}
//                 onChange={(e) => handleOtpChange(index, e.target.value)}
//                 className="w-12 h-12 text-center border border-gray-300 bg-[#F1F4F9] rounded-md text-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
//               />
//             ))}
//           </div>

//           <p className="text-sm text-gray-500 mb-6">
//             Send code again <span className="text-black font-medium">00:{timer.toString().padStart(2, '0')}</span>
//           </p>

//           <button   onClick={() => navigate('/priceplans')}
//             type="button"
//             className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition"
//           >
//             Verify
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignupPassword;
// import React, { useState, useEffect } from 'react';
// import Logo from '../../assets/Logo.svg';
// import bgImage from "../../assets/back.png";
// import { useNavigate, useLocation } from 'react-router-dom';
// import { registrationVerification } from '../../ApiController/ApiService';
// import Swal from 'sweetalert2';

// const OtpVerification = () => {
//   const [otp, setOtp] = useState(['', '', '', '', '', '']);
//   const [timer, setTimer] = useState(20);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { email, otp: receivedOtp } = location.state || {};

//   useEffect(() => {
//     if (receivedOtp) {
//       Swal.fire({
//         title: 'OTP Sent',
//         text: `Your OTP is: ${receivedOtp}`,
//         icon: 'success',
//         confirmButtonText: 'OK',
//       });
//     }

//     const countdown = setInterval(() => {
//       setTimer(prev => (prev > 0 ? prev - 1 : 0));
//     }, 1000);
//     return () => clearInterval(countdown);
//   }, [receivedOtp]);

//   const handleOtpChange = (index, value) => {
//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);
//     if (value && index < 5) {
//       document.getElementById(`otp-${index + 1}`).focus();
//     }
//   };

//   const handleVerify = async () => {
//     const enteredOtp = otp.join('');
//     try {
//       const result = await registrationVerification({ email, otp: enteredOtp });
//       console.log("Verification Success:", result);
//       Swal.fire({
//         title: 'Verification Successful',
//         text: 'Your account has been verified!',
//         icon: 'success',
//         confirmButtonText: 'Proceed',
//       }).then(() => {
//         navigate('/priceplans');
//       });
//     } catch (error) {
//       Swal.fire({
//         title: 'Verification Failed',
//         text: error.message || 'Invalid OTP. Please try again.',
//         icon: 'error',
//         confirmButtonText: 'OK',
//       });
//     }
//   };

//   return (
//     <div
//       className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
//       style={{ backgroundImage: `url(${bgImage})` }}
//     >
//       <div className="flex flex-col items-center relative">
//         <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

//         <div className="bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[384px] p-8 text-center">
//           <h2 className="text-xl font-bold text-[#2D0076] mb-2">Please Check your email</h2>
//           <p className="text-sm text-[#202224] mb-6">We have sent a code to {email || 'your email'}</p>

//           <div className="flex justify-center gap-3 mb-4">
//             {otp.map((digit, index) => (
//               <input
//                 key={index}
//                 id={`otp-${index}`}
//                 type="text"
//                 maxLength="1"
//                 value={digit}
//                 onChange={(e) => handleOtpChange(index, e.target.value)}
//                 className="w-12 h-12 text-center border border-gray-300 bg-[#F1F4F9] rounded-md text-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
//               />
//             ))}
//           </div>

//           <p className="text-sm text-gray-500 mb-6">
//             Send code again <span className="text-black font-medium">00:{timer.toString().padStart(2, '0')}</span>
//           </p>

//           <button
//             onClick={handleVerify}
//             type="button"
//             className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition"
//           >
//             Verify
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OtpVerification;
import React, { useState, useEffect } from 'react';
import Logo from '../../assets/Logo.svg';
import bgImage from "../../assets/back.png";
import { useNavigate, useLocation } from 'react-router-dom';
import { registrationVerification, forgetPassword } from '../../ApiController/ApiService';
import Swal from 'sweetalert2';

const OtpVerification = () => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(20);
  const navigate = useNavigate();
  const location = useLocation();
  const { email, otp: receivedOtp } = location.state || {};

  // useEffect(() => {
  //   if (receivedOtp) {
  //     Swal.fire({
  //       title: 'OTP Sent',
  //       text: `Your OTP is: ${receivedOtp}`,
  //       icon: 'success',
  //       confirmButtonText: 'OK',
  //     });
  //   }

  //   const countdown = setInterval(() => {
  //     setTimer(prev => (prev > 0 ? prev - 1 : 0));
  //   }, 1000);
  //   return () => clearInterval(countdown);
  // }, [receivedOtp]);

  const handleOtpChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleResendCode = async () => {
    if (timer > 0) return; // Prevent resending while timer is active
    try {
      const forgetPasswordResult = await forgetPassword({ email });
      // console.log("Resend OTP Success:", forgetPasswordResult);
      setOtp(['', '', '', '', '', '']); // Reset OTP inputs
      setTimer(20); // Reset timer
      // Swal.fire({
      //   title: 'New OTP Sent',
      //   text: `Your new OTP is: ${forgetPasswordResult.data.otp}`,
      //   icon: 'success',
      //   confirmButtonText: 'OK',
      // });
    } catch (error) {
      Swal.fire({
        title: 'Resend Failed',
        text: error.message || 'Failed to resend OTP. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

const handleVerify = async () => {
  const enteredOtp = otp.join(''); // OTP array ko string me convert
  try {
    const result = await registrationVerification({ email, otp: enteredOtp });

    console.log("Verification Success:", result);

    if (result?.status === 200 && result?.data) {
      const { userId, accessToken } = result.data;

      // ✅ Local storage me save karna
      localStorage.setItem("userId", userId);
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("isVerified", "true");

      Swal.fire({
        title: 'Verification Successful',
        text: 'Your account has been verified!',
        icon: 'success',
        confirmButtonText: 'Proceed',
      }).then(() => {
        navigate('/singup/create-profile'); // profile creation page par bhejna
      });
    } else {
      throw new Error(result.message || "Verification failed.");
    }

  } catch (error) {
    console.error("Verification Error:", error);

    Swal.fire({
      title: 'Verification Failed',
      text: error.message || 'Invalid OTP. Please try again.',
      icon: 'error',
      confirmButtonText: 'OK',
    });
  }
};


  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center relative"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="flex flex-col items-center relative">
        <img src={Logo} alt="Logo" className="mb-4 w-[263px] z-10" />

        <div className="bg-white mb-4 rounded-2xl shadow-xl w-full sm:w-[384px] p-8 text-center">
          <h2 className="text-xl font-bold text-[#2D0076] mb-2">Please Check your email</h2>
          <p className="text-sm text-[#202224] mb-6">We have sent a code to {email || 'your email'}</p>

          <div className="flex justify-center gap-3 mb-4">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                className="w-12 h-12 text-center border border-gray-300 bg-[#F1F4F9] rounded-md text-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            ))}
          </div>

          <p className="text-sm text-gray-500 mb-6">
            <span
              onClick={handleResendCode}
              className={`cursor-pointer ${timer > 0 ? 'text-gray-500' : 'text-blue-500 hover:underline'}`}
            >
              Send code again
            </span>{' '}
            <span className="text-black font-medium">00:{timer.toString().padStart(2, '0')}</span>
          </p>

          <button
            onClick={handleVerify}
            type="button"
            className="w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition"
          >
            Verify
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;